<template>
  <div class="custom-wrapper">
    <div class="row">
      <div class="col">
        <table class="custom-table">
          <tr>
            <td class="custom-location">{{ opportunity.sourceFirmName }}</td>
            <td class="text-right">Inspection #{{ opportunity.adasInspection }}</td>
          </tr>
          <tr>
            <td>Estimator: {{ opportunity.estimator }}</td>
            <td class="text-right">{{ opportunity.insurance }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="custom-listing mt-2">
      <table class="table table-bordered table-striped">
        <thead class="bg-white table-sticky">
          <tr>
            <th v-for="column in tableColumnsName" :key="column.field" :class="column.class">
              <span>{{ column.label }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(line, index) in lines" :key="index">
            <td>{{ line.id }}</td>
            <td>{{ line.category }}</td>
            <td>{{ line.location }}</td>
            <td>{{ line.system }}</td>
            <td>{{ line.calibration }}</td>
            <td class="text-right">{{ line.amount }}</td>
            <td v-if="!isLocked" class="custom-offer-price">
              <input
                :value="line.offerPrice || line.amount"
                type="number"
                min="0"
                max="99999"
                class="form-control text-right"
                @keyup="setOfferPrice(line.id, $event.target.value)"
              />
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5" class="text-right custom-opportunity">Total:</td>
            <td class="text-right custom-opportunity">{{ formatNumber(opportunity.price) }}</td>
            <td v-if="!isLocked" class="text-right custom-opportunity">{{ formatNumber(opportunity.offerPrice) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div v-if="!isLocked" class="row">
      <div class="col-3">
        <div class="input-group">
          <span class="input-group-text">Offer Expires On:</span>
          <input type="date" class="form-control" v-model="opportunity.expiresOn" @change="changed" />
        </div>
      </div>
      <div class="col-4">
        <div class="input-group">
          <span class="input-group-text">Notes:</span>
          <textarea class="form-control custom-notes" v-model="opportunity.notes" @keyup="changed"></textarea>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookupStore } from '@/stores/lookup'
import { opportunityStore } from '@/stores/opportunity'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ZTable from '@/components/utilities/elements/Table.vue'
export default {
  name: 'OpportunityBasic',
  components: {
    ZInput,
    ZSelect,
    ZTable
  },
  props: {
    firm: [Object, Number]
  },
  data() {
    return {}
  },
  emits: ['changed', 'saved', 'export', 'push'],
  computed: {
    ...mapState(lookupStore, ['userRoles']),
    ...mapState(opportunityStore, ['opportunity']),
    isLocked() {
      let _is = false
      if (this.opportunity) {
        _is = this.opportunity.isPriceIncluded
      }
      return _is
    },
    tableColumnsName() {
      let columns = [
        {
          field: 'id',
          label: 'Id',
          sortable: false,
          class: 'custom-column-80 text-center'
        },
        {
          field: 'category',
          label: 'Category',
          sortable: false
        },
        {
          field: 'location',
          label: 'Location',
          sortable: false
        },
        {
          field: 'system',
          label: 'System',
          sortable: false
        },
        {
          field: 'calibration',
          label: 'Calibration',
          sortable: false
        },
        {
          field: 'amount',
          label: 'Amount',
          sortable: false,
          class: 'custom-column-100 text-right'
        }
      ]
      if (!this.isLocked) {
        columns.push({
          field: 'id',
          label: 'Offer',
          sortable: false,
          class: 'custom-column-130 text-center'
        })
      }
      return columns
    },
    lines() {
      let _lines = []
      if (this.opportunity) {
        this.opportunity.lines.forEach((element) => {
          if (element.adasInspectionResult) {
            _lines.push({
              id: parseInt(element.adasInspectionResult),
              category: element.item,
              location: element.location,
              system: element.attribute,
              calibration: element.calibrationTypeName,
              amount: element.calibrationPrice?.toFixed(2),
              offerPrice: element.offerPrice?.toFixed(2)
            })
          }
        })
      }
      return _lines
    }
  },
  methods: {
    ...mapActions(opportunityStore, ['setOpportunity']),
    changed() {
      this.$emit('changed')
    },
    formatNumber(value) {
      return value?.toFixed(2)
    },
    setOfferPrice(id, value) {
      this.setOpportunity({
        name: 'line',
        value: {
          id: id,
          offerPrice: parseFloat(value)
        }
      })
      this.changed()
    },
    async push() {
      this.$emit('push')
    },
    async export() {
      this.$emit('export')
    },
    async save() {
      // validate here

      let response = {
        valid: false,
        contact: null,
        msg: null
      }
      this.$emit('saved')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
  padding: auto;
}
.custom-table {
  width: 100%;
}
.custom-opportunity {
  font-weight: 600;
}
.custom-location {
  font-weight: 600;
}
.custom-listing {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 300px;
  height: 300px;
}
.custom-offer-price {
  width: 130px;
}
.custom-notes {
  height: 100px;
}
</style>
